import React from 'react';
import {formTabMobileTheme, formTabTheme} from '../../theme/tabBarTheme';
import FormTabNavigator from '../tab/FormTabNavigator';
import {isMobile} from '../UtilityFunctions';
import {getResolvedGroups} from './Utility';

class FormTabScreen extends React.Component {
  render() {
    let {children} = this.props;
    return children;
  }
}

export const FormTab = props => {
  let theme = isMobile ? formTabMobileTheme : formTabTheme;
  let {tabs, renderFormGroups, ...restProps} = props;
  let formTabs = {};
  for (let tabKey in tabs) {
    let {formGroups, ...restTabInfo} = tabs[tabKey];
    if (formGroups) {
      formGroups = getResolvedGroups(formGroups, restProps);
    }
    formTabs[tabKey] = {
      ...restTabInfo,
      screen: FormTabScreen,
      screenProps: {
        key: tabKey,
        children: renderFormGroups({formGroups}),
      },
    };
  }
  return <FormTabNavigator {...theme} tabs={formTabs} {...restProps} />;
};
